/**
 * MSW Overrides: Booking Confirm Quota scenario
 *
 * Returns the real booking payment response but with `quota` injected at
 * the top level of the response (alongside `id`, `bookingStatus`, etc.).
 * These represent the subscription credit breakdown shown on the booking
 * confirmation page (after the booking has been confirmed).
 *
 * Enable by setting ENABLE_MSW=true and NUXT_PUBLIC_MSW_OVERRIDES_BOOKING_CONFIRM_QUOTA=true
 * in your .env, then restart the dev server.
 */

import type { HttpHandler } from 'msw';
import { http, HttpResponse, bypass } from 'msw';
import { BFF_ENDPOINTS, toMSWPattern } from '@cvo/domain';
import type { BookingListQuota, BookingResponse } from '@cvo/domain';

export const MOCK_BOOKING_CONFIRM_QUOTA: BookingListQuota = {
  consumed: 3,
  availableBefore: 10,
  availableAfter: 7,
};

export function createBookingConfirmQuotaOverrides(baseUrl: string): HttpHandler[] {
  const sanitizedBaseUrl = baseUrl.replace(/\/$/, '');

  return [
    http.post(
      `${sanitizedBaseUrl}/${toMSWPattern(BFF_ENDPOINTS.BOOKING_PAYMENTS)}`,
      async ({ request }) => {
        const originalResponse = await fetch(bypass(request));
        const data: BookingResponse = await originalResponse.json();

        const result = {
          ...data,
          quota: MOCK_BOOKING_CONFIRM_QUOTA,
        };

        console.log('[MSW] booking confirm quota injected:', result.quota);

        return HttpResponse.json(result);
      },
    ),
  ];
}
